import { Col, Form, Row, Select, Space, Table } from 'antd';
import { EyeIcon, FilterGoldIcon, FilterIcon } from 'assets/svg';
import { MainLayout } from 'components';
import { useFormik } from 'formik';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import formatDateMDY from 'utils/formatDateMDY';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { useMutation, useQuery } from 'react-query';
import AllocateApi from 'apis/AllocateApi';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import { useHistory } from 'react-router-dom';
import {
  translateAllocateStatus,
  translateStatus,
} from 'constants/allocateStatus';
import moment from 'moment';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { useUser } from 'contexts/User';

type FixedType = 'left' | 'right' | boolean;

export default function BranchCapital() {
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [allowcateData, setAllocateData] = useState<any>();
  const { user } = useUser();
  const queryParam = useQueryParam();
  const history = useHistory();
  const [total, setTotal] = useState<number>(0);
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const pagination = { page: page, page_size: page_size };
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      area: '',
      branch_code: '',
      fin_year: '',
    },
    onSubmit(values) {
      const newValues = {
        ...values,
      };
      console.log(newValues);
    },
  });
  const handleChangeSelect = (name: string) => {
    return (value: any) => {
      formik.setFieldValue(name, value);
    };
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Khu vực',
      dataIndex: 'area_name',
      width: 160,
    },
    {
      title: 'Mã chi nhánh',
      dataIndex: 'branch_code',
      width: 200,
    },
    {
      title: 'Tên chi nhánh',
      dataIndex: 'capital_name',
      width: 350,
    },
    {
      title: 'Tổng vốn chi nhánh',
      dataIndex: 'capital_value',
      width: 200,
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Tổng vốn phân bố max cửa hàng',
      dataIndex: 'total_capital_max',
      width: 220,
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Tổng vốn phân bố min cửa hàng',
      dataIndex: 'total_capital_min',
      width: 220,
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Tống vốn đã phê duyệt max',
      dataIndex: 'capital_order_max',
      width: 220,
    },
    {
      title: 'Tống vốn đã phê duyệt min',
      dataIndex: 'capital_order_min',
      width: 220,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      width: 220,
      render: (_: any, record: any) => (
        <span>{translateStatus(record.status)}</span>
      ),
    },
    {
      title: 'Trạng thái phân bổ',
      dataIndex: 'status_allocation',
      width: 160,
      render: (_: any, record: any) => (
        <span>{translateAllocateStatus(record.status_allocation)}</span>
      ),
    },
    {
      title: 'Cửa hàng được phân bổ',
      width: 220,
    },
    {
      title: 'Người tạo',
      dataIndex: 'created_by',
      width: 150,
    },
    {
      title: 'Người cập nhật lần cuối',
      dataIndex: 'updated_by',
      width: 200,
    },
    {
      title: 'Thời gian cập nhật lần cuối',
      dataIndex: 'updated_at',
      width: 220,
      render: (updated_at) => {
        return updated_at ? moment(updated_at).format('DD/MM/YYYY') : '';
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 150,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          <button
            onClick={() => history.push('/branchs-capital-detail', record)}
          >
            <EyeIcon />
          </button>
        </div>
      ),
    },
  ];

  const params = {
    page: page,
    page_size: page_size,
  };

  const {
    data: getAllocated,
    isLoading: getLoading,
    mutate: refresh,
  } = useMutation(['get'], () => AllocateApi.getAllocation(params), {
    onSuccess: (response: any) => {
      if (response.status === STATUS.SUCCESS) {
        setAllocateData(response?.data);
        setTotal(response?.total);
      }
    },
    onError: (error: any) => {
      if (error.response.data.status === 401) {
        handleError401();
      }
    },
  });

  useEffect(() => {
    setTitle('Vốn tồn chi nhánh');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Thông tin đơn vị</a>
          </p>
        ),
      },
      { title: <a href="/branchs-capital">Vốn tồn chi nhánh</a> },
    ]);
    if (user?.plantCode) {
      refresh();
    }
  }, [user?.plantCode, page, page_size]);

  return (
    <MainLayout>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col>
          <Space>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
        autoComplete="off"
        onSubmitCapture={formik.handleSubmit}
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="area" label="Khu vực">
                <Select
                  onChange={handleChangeSelect('area')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="branch_code" label="Mã chi nhánh">
                <Select
                  onChange={handleChangeSelect('branch_code')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="fin_year" label="Năm tài chính">
                <Select
                  onChange={handleChangeSelect('fin_year')}
                  defaultValue={'Tất cả'}
                  size="middle"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={toggleFilter}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="mt-4 main-content">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={allowcateData}
          scroll={{ x: 958 }}
          //   loading={getCartsLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
